/* eslint-disable indent */
import { Typography, Box, Container, List, ListItem, Link, createTheme, ThemeProvider } from '@mui/material';
import * as CommonLicenseProps from './CommonLicenseProps';

//Custom theme using createTheme
const theme = createTheme(
{
  typography:
  {
    fontFamily: "Inter", // Change the default font-family
  }
});

const CopyrightLicenseAgreementArtist = () =>
{
  return (
    <>
    <ThemeProvider theme={theme}>
      <Container maxWidth="lg">
        <Box sx={CommonLicenseProps.pageProps}>
          {/* Page Header */}
          <Typography sx={CommonLicenseProps.pageTitleProps}>
            Copyright License Agreement (Artist)
          </Typography>

          {/* Introduction */}
          <Typography sx={CommonLicenseProps.normalParaProps}>
            This COPYRIGHT LICENSE AGREEMENT (the “<Typography sx={CommonLicenseProps.emphasizedText}>Agreement</Typography>”) is made by and between the User (“<Typography sx={CommonLicenseProps.emphasizedText}>Artist</Typography>”) and Saagas.AI Inc. a Delaware corporation (“<Typography sx={CommonLicenseProps.emphasizedText}>Saagas</Typography>”).
          </Typography>

          {/* Recitals */}
          <Typography sx={CommonLicenseProps.sectionHeadingProps}>
            Recitals
          </Typography>
          <List sx={CommonLicenseProps.upperAlphaListProps}>
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.bulletParaProps}>
                WHEREAS Saagas uses machine-learning technology to capture artistic styles and features from pre-existing artwork to generate derivative artwork which Saagas then licenses to its customers for personal and/or commercial use; and
              </Typography>
            </ListItem>
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.bulletParaProps}>
                WHEREAS Artist solely and exclusively owns and controls the Work (as defined below) and wishes to grant to Saagas a license to the Work and Saagas wishes to obtain a license to the Work for the uses and purposes described herein, each subject to the terms and conditions set forth herein.
              </Typography>
            </ListItem>
          </List>

          {/* Agreement */}
          <Typography sx={CommonLicenseProps.sectionHeadingProps}>
            Agreement
          </Typography>

          <Typography sx={CommonLicenseProps.normalParaProps}>
            NOW, THEREFORE, in consideration of the mutual covenants, terms, and conditions set forth herein, and for other good and valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the parties agree as follows:
          </Typography>

          <List sx={CommonLicenseProps.decimalListProps}>
            {/* Section 1 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                License
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Grant of Rights
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Subject to the terms and conditions of this Agreement, Artist hereby grants to Saagas and its affiliates during the Term (as defined below) a non-exclusive, irrevocable, fully transferable (in accordance with Section 10.4), sublicensable (in accordance with Section 1.5) right and license anywhere in the world (the “<Typography sx={CommonLicenseProps.emphasizedText}>Territory</Typography>”), to do all of the following:
                  </Typography>
                  <List sx={CommonLicenseProps.lowerAlphaListProps}>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        reproduce,display, alter, modify, transmit,anddistribute all of Artist’s original artwork that is delivered to Saagas under this Agreement (collectively, “<Typography sx={CommonLicenseProps.emphasizedText}>Work</Typography>”)in any and all formats and media whether now or hereafter known or devised and by any and all technologies and means of delivery whether now or hereafter known or devised;
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        generate derivative works of the Work (collectively, “<Typography sx={CommonLicenseProps.emphasizedText}>Derivative Work</Typography>”), in any and all formats and media whether now or hereafter known or devisedand by any and all technologies and means of delivery whether now or hereafter known or devised; and
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        use Artist’s name, image, biographical data and information (including information Artist provides to Saagas and any other information about Artist that is publicly available) in any and all media and by any and all technologies and means of delivery now or hereafter known or devised, including to perform the obligations set forth in ‎2 or to advertise and promote Saagas’s business and/or services, without further consent from, or any payment or other compensation to, Artist.
                      </Typography>
                    </ListItem>
                  </List>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Express Grant of Rights with respect to Derivative Works
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Artist expressly understands and agrees that the grant of rights set forth in Section 1.1 includes the right for Saagas (i) to use the Work for training refining and operating Saagas’s generative artificial intelligence program to create Derivative Work and (ii) to sell or license such Derivative Works to third parties (“<Typography sx={CommonLicenseProps.emphasizedText}>Customers</Typography>”) for a fee in each case without the necessity of any further grant of rights by Artist.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    No Obligation; No Guarantees
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Saagas may use the Work in accordance with this Agreement at Saagas’s sole discretion. This Agreement neither obligates Saagas to use the Work in connection with its business including to generate Derivative Work nor guarantees Artist any Licensing Fees (as defined below) or other remuneration from Saagas.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Waiver of Moral Rights
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Except as otherwise expressly set forth in Section 2, Artist irrevocably waives, to the extent permitted by applicable law, all rights of paternity, integrity, attribution, disclosure, withdrawal, and any other rights that may be known as “moral rights” (“<Typography sx={CommonLicenseProps.emphasizedText}>Moral Rights</Typography>”) with respect to the use of the Work and Derivative Work. To the extent this waiver is not permitted by applicable law, Artist hereby agrees not to enforce such Moral Rights against Saagas, its permitted successors, licensees, sublicensees, and assigns, and any Customers.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Sublicensing
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Saagas may sublicense the rights granted under Section 1.1 in its sole and exclusive discretion.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Permissions
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Artist represents and warrants to Saagas that Artist has obtained from any and all persons and entities who provided services for or participated in, or are, or whose trademark, copyright, or other property is, identified, depicted, or otherwise referred to in the Work, such written and signed licenses, permissions, waivers, and consents (collectively, “<Typography sx={CommonLicenseProps.emphasizedText}>Permissions</Typography>,” and each, individually, a “<Typography sx={CommonLicenseProps.emphasizedText}>Permission</Typography>”), including those relating to publicity, privacy, and any intellectual property rights, as are or reasonably may be expected to be necessary for Saagas to exercise its rights in the Work as permitted by this Agreement, without incurring any payment or other obligation to, or otherwise violating any right of, any such person or entity.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 2 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Copyright Notice; Attribution
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Work
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Work displayed on Saagas’s website(s) and/or app(s) will be marked with the appropriate copyright notices in a reasonably prominent position.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Derivative Work
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    No attribution will be provided with respect to Derivative Work.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 3 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Payment
              </Typography>
              <Typography sx={CommonLicenseProps.normalParaProps}>
                As consideration in full for the rights granted herein, Saagas shall pay Artist a fee (a “<Typography sx={CommonLicenseProps.emphasizedText}>Licensing Fee</Typography>”) based on the money actually received by Saagas from Customers with respect to Derivative Work. The Licensing Fee will be calculated and paid in accordance with terms set forth in the Licensing Fee Schedule attached hereto as Exhibit A.
              </Typography>
            </ListItem>

            {/* Section 4 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Ownership or Work and Derivative Work
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Work
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Except for the licenses expressly granted to Saagas in this Agreement, as between Saagas and Artist, all right, title, and interest in and to the Work are owned by Artist. Saagas agrees not to dispute or challenge, or assist any person or entity in disputing or challenging, Artist’s rights in and to the Work.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Derivative Work
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Except for as expressly set forth in Section 2.2, all right, title and interest in and to Derivative Work will be owned by Saagas. Artist agrees not to dispute or challenge, or assist any person or entity in disputing or challenging, Saagas’s rights in and to Derivative Work.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 5 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Confidentiality
              </Typography>
              <Typography sx={CommonLicenseProps.normalParaProps}>
                Artist acknowledges that, in connection with this Agreement, it may gain access to information that is treated as confidential by Saagas, including information about Saagas’s business affairs, confidential intellectual property, trade secrets, third-party confidential information, and other sensitive or proprietary information, including the terms of the Agreement and business operations and strategies, marketing, creative elements, artwork, visual representations, research material and data, specifications, processes, and technological developments, whether orally or in written, electronic, or other form or media, and whether or not marked, designated, or otherwise identified as “confidential” (collectively, “<Typography sx={CommonLicenseProps.emphasizedText}>Confidential Information</Typography>”). Confidential Information does not include information that, at the time of disclosure and as established by documentary evidence: (a) is or becomes generally available to and known by the public other than as a result of, directly or indirectly, any breach of this Section by Artist; (b) is or becomes available to Artist on a non-confidential basis from a third-party source, provided that such third party is not and was not prohibited from disclosing such Confidential Information; (c) was known by or in the possession of Artist before being disclosed by or on behalf of Saagas; or (d) was or is independently developed by Artist without reference to or use, in whole or in part, of any of Confidential Information. Artist shall: (i) protect and safeguard the confidentiality of Confidential Information with at least the same degree of care as Artist would protect its own Confidential Information, but in no event with less than a commercially reasonable degree of care; (ii) not use Confidential Information, or permit it to be accessed or used, for any purpose other than as set forth in this Agreement; and (iii) not disclose any such Confidential Information to any person or entity, except: (A) to Artist’s officers, employees, agents, consultants, and legal advisors who need to know the Confidential Information to assist Artist, or act on its behalf, to exercise its rights or perform its obligations under the Agreement; or (B) pursuant to applicable federal, state, or local law or regulation, or a valid order issued by a court or governmental agency of competent jurisdiction, provided that Artist shall first provide Saagas with prompt written notice of such requirement so that Saagas may seek, at its sole cost and expense, a protective order or other remedy.
              </Typography>
            </ListItem>

            {/* Section 6 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Representations and Warranties
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Mutual Representations and Warranties
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Each party represents and warrants to the other party that:
                  </Typography>
                  <List sx={CommonLicenseProps.lowerAlphaListProps}>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        it has the full right, power, and authority to enter into this Agreement and to perform its obligations hereunder; and
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        when executed and delivered by such party, this Agreement will constitute the legal, valid, and binding obligation of such party, enforceable against such party in accordance with its terms.
                      </Typography>
                    </ListItem>
                  </List>
                </ListItem>


                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Artist’s Representations and Warranties
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Artist represents and warrants that:
                  </Typography>
                  <List sx={CommonLicenseProps.lowerAlphaListProps}>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        Artist has read, understands, and at all times will adhere to Saagas’s Terms of Use, available <Link target="_blank" rel="noopener noreferrer" href="/terms-of-use">here</Link>, and which are incorporated by reference here.
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        it solely and exclusively owns the right, title, and interest in and to the Work and has the full right, power, and authority to grant the rights and licenses granted hereunder;
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        it has not granted, and during the Term will not grant, any liens, security interests, or other encumbrances in, to, or under the Work, and no consents from or payments to any third party are or will be required by Artist’s grant and license of rights to Saagas hereunder or by Saagas’s exercise of such rights;
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        the exercise by Saagas of the rights and license granted under this Agreement will not infringe or otherwise conflict with the rights of any other person or entity;
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        there is no settled, pending, or threatened litigation, opposition, or other claim or proceeding challenging the validity, enforceability, ownership, registration, or use of the Work; and
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        it has not brought or threatened any claim against any third party alleging infringement of the Work, nor is any third party infringing or threatening to infringe the Work.
                      </Typography>
                    </ListItem>
                  </List>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 7 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Indemnification
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Scope of Indemnification
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Artist shall indemnify, defend, and hold harmless Saagas and its affiliates, officers, directors, employees, agents, sublicensees, successors, and assigns (each, a “<Typography sx={CommonLicenseProps.emphasizedText}>Indemnified Party</Typography>”) from and against all losses, damages, liabilities, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, fees, costs, or expenses of whatever kind, including reasonable attorneys’ fees, the cost of enforcing any right to indemnification hereunder, and the cost of pursuing any insurance providers (collectively, “<Typography sx={CommonLicenseProps.emphasizedText}>Losses</Typography>”) arising out of or in connection with any third-party claim, suit, action, or proceeding (“<Typography sx={CommonLicenseProps.emphasizedText}>Third-Party Claim</Typography>”): (a) relating to any actual or alleged material breach or misrepresentation by Artist of, inaccuracy in, or failure to perform, any representation, warranty, covenant, or other obligation hereunder; (b) resulting directly or indirectly from the Work or use of the Work by Saagas in accordance with this Agreement, including failure to obtain any required Permission, or infringement or other violation of any intellectual property or other rights of any person or entity resulting from the use of the Work by in accordance with this Agreement; or (c) resulting directly or indirectly from Derivative Work or use of Derivative Work by Saagas or its Customers, including failure to obtain any required Permission, or infringement or other violation of any intellectual property or other rights of any person or entity resulting from such use of Derivative Work.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Indemnification Procedure
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Each party shall promptly notify the other party on becoming aware of a Third-Party Claim with respect to which Artist is obligated to provide indemnification under this Section 7 (“<Typography sx={CommonLicenseProps.emphasizedText}>Indemnified Claim</Typography>”). Artist shall promptly assume control of the defense and investigation of the Indemnified Claim, with counsel reasonably acceptable to Saagas, and Saagas shall cooperate with Artist in connection therewith, in each case at Artist’s sole cost and expense. Saagas may participate in the defense of such Indemnified Claim, with counsel of its own choosing and at its own cost and expense. Artist will not settle any Indemnified Claim on any terms or in any manner that adversely affects the rights of Saagas without Saagas’s prior written consent. If Artist fails or refuses to assume control of the defense of such Indemnified Claim, the Indemnified Party will have the right, but no obligation, to defend against such Indemnified Claim, including settling such Indemnified Claim, in each case in such manner and on such terms as the Indemnified Party may deem appropriate. Neither Saagas’s failure to perform any obligation under this Section 7 nor any Indemnified Party’s act or omission in the defense or settlement of any Indemnified Claim will relieve Artist of its obligations under this Section 7, including with respect to any Losses, except to the extent that Artist can demonstrate that it has been materially prejudiced as a result thereof.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 8 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Term and Termination
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Term
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    The term of this Agreement commences as of the Effective Date and will remain in force unless and until terminated as provided herein (the “<Typography sx={CommonLicenseProps.emphasizedText}>Term</Typography>”).
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Termination by Saagas
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Saagas may terminate this Agreement at any time without cause by providing written notice to Artist.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Termination for Cause
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Either party may terminate this Agreement on written notice to the other party if the other party materially breaches this Agreement and fails to cure such breach within 20 days after receiving written notice thereof.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Effect of Termination
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    On the expiration or termination of this Agreement for any reason, all rights licensed under this Agreement with respect to the Work (but not Derivative Work) will revert immediately to Artist and, subject to the Wind-Down Period as expressly permitted below, Saagas shall cause to be inactivated and erased all digital copies of the Work in its control and possession and destroy any tangible copies of the Work; provided, however, that (a) Saagas may retain a digital copy of the Work solely for purposes of responding to claims or inquiries relating to the Work, and (b) Saagas will have a period of 60 days after such termination (“<Typography sx={CommonLicenseProps.emphasizedText}>Wind-Down Period</Typography>”) to continue commercial exploitation of the Work in accordance with the terms and conditions of its license hereunder.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Surviving Rights
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Any rights or obligations of the parties in this Agreement which, by their nature, should survive termination or expiration of this Agreement will survive any such termination or expiration, including the rights and obligations set forth in this Section 8 and Section 1.6, Section 3 (unless Saagas terminates this Agreement pursuant to Section 8.3), Section 4, Section 5, Section 6, Section 7, Section 9, and Section 10 (excluding Section 10.5).
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 9 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                Remedies
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    No Equitable Relief
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Artist acknowledges and agrees that: (a) monetary damages at law are a fully adequate remedy to compensate Artist for any breach or threatened breach of this Agreement by Saagas; and (b) an action at law for monetary damages is Artist’s sole and exclusive remedy for any such breach. No breach by Saagas of this Agreement will entitle Artist to equitable relief, including specific performance, injunctive relief, rescission, or any other form of equitable remedy. Without limiting the generality of the immediately preceding two sentences, Artist will not seek equitable relief to rescind this Agreement or seek injunctive relief to enjoin or otherwise restrain or limit the use or other exploitation of the Work or Derivative Work or any rights therein.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Limitation of Liability
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEITHER PARTY WILL BE LIABLE TO THE OTHER PARTY UNDER OR IN CONNECTION WITH THIS AGREEMENT FOR ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, PUNITIVE, OR ENHANCED DAMAGES, OR FOR ANY LOSS OF ACTUAL OR ANTICIPATED PROFITS (REGARDLESS OF HOW THESE ARE CLASSIFIED AS DAMAGES), WHETHER ARISING OUT OF BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE (INCLUDING THE ENTRY INTO, PERFORMANCE, OR BREACH OF THIS AGREEMENT), REGARDLESS OF WHETHER SUCH DAMAGE WAS FORESEEABLE AND WHETHER EITHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATIONS DO NOT APPLY TO: (A) ARTIST’S INDEMNIFICATION OBLIGATIONS UNDER SECTION 7; OR (B) LOSSES ARISING OUT OF OR RELATING TO ARTIST’S FAILURE TO COMPLY WITH THE CONFIDENTIALITY OBLIGATIONS UNDER SECTION 5.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>

            {/* Section 10 */}
            <ListItem sx={CommonLicenseProps.listItemProps}>
              <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                General
              </Typography>
              <List sx={CommonLicenseProps.decimalListProps}>
                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Interpretation
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    For purposes of this Agreement: (a) the words “include,” “includes,” and “including” are deemed to be followed by the words “without limitation”; (b) the word “or” is not exclusive; and (c) the words “herein,” “hereof,” “hereby,” “hereto,” and “hereunder” refer to this Agreement as a whole. This Agreement is intended to be construed without regard to any presumption or rule requiring construction or interpretation against the party drafting an instrument or causing any instrument to be drafted.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Binding Agreement
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    This Agreement shall be binding upon and shall inure to the benefit of the successors and assigns of the respective parties hereto.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Entire Agreement
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    This Agreement, together with any exhibits or other attachments (which are hereby expressly incorporated into this Agreement), is the sole and entire agreement of the parties with respect to the subject matter herein, and supersedes all prior and contemporaneous understandings, agreements, representations, and warranties, whether written or oral, regarding such subject matter.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Severability
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    If any term or provision of this Agreement is invalid, illegal, or unenforceable in any jurisdiction, such invalidity, illegality, or unenforceability will not affect the enforceability of any other term or provision of this Agreement or invalidate or render unenforceable such term or provision in any other jurisdiction.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Assignment
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Saagas may freely assign or otherwise transfer all or any of its rights, or delegate or otherwise transfer all or any of its obligations or performance, under this Agreement without Artist’s consent. This Agreement is binding upon and inures to the benefit of the parties hereto and their respective permitted successors and assigns.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Governing Law
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    This Agreement and all matters arising out of or relating to this Agreement are governed by, and construed in accordance with, the laws of the State of Washington, without giving effect to any conflict of laws provisions thereof that would require or permit the application of the laws of a different jurisdiction.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Arbitration
                  </Typography>
                  <List sx={CommonLicenseProps.lowerAlphaListProps}>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        Except as otherwise provided in Section 10.7(d), any dispute, controversy, or claim arising out of the subject matter of this Agreement will be settled by arbitration before a single arbitrator in Seattle, Washington.
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        The arbitration will be initiated by filing a claim with American Arbitration Association and will be conducted by an arbitrator knowledgeable in business law in accordance with the then-current rules of American Arbitration Association.
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        The resolution of any dispute, controversy, or claim as determined by the arbitrator will be binding on the parties. Judgment on the award of the arbitrator may be entered by any party in any court having jurisdiction.
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        A party may seek from a court an order to compel arbitration, or any other interim relief or provisional remedies pending an arbitrator’s resolution of any dispute, controversy, or claim. Any such action, suit, or proceeding will be litigated in courts located in Seattle, Washington.
                      </Typography>
                    </ListItem>
                    <ListItem sx={CommonLicenseProps.listItemProps}>
                      <Typography sx={CommonLicenseProps.bulletParaProps}>
                        For the purposes set forth in Section 10.7(d), each party consents and submits to the jurisdiction of any local, state, or federal court located in Seattle, Washington.
                      </Typography>
                    </ListItem>
                  </List>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Contra Proferentem
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    The doctrine of contra proferentem shall not apply to this Agreement. Any rule of law or any legal decision that would require interpretation of any claimed ambiguities in this Agreement against the drafting party has no application and is expressly waived.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Relationship of the Parties
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    Nothing contained in this Agreement will be construed as creating any agency, partnership, joint venture, or other form of joint enterprise, employment, or fiduciary relationship between the parties, and neither party has authority to contract for or bind the other party in any manner whatsoever.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    No Third-Party Beneficiaries
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    This Agreement is for the sole benefit of the parties hereto and their respective successors and permitted assigns, and nothing herein, express or implied, is intended to or will confer upon any third party any legal or equitable right, benefit, or remedy of any nature whatsoever, under or by reason of this Agreement.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Amendment and Modification
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    No amendment or modification to this Agreement is effective unless it is in writing and signed by an authorized representative of each party.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Waiver
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    No waiver by any party of any of the provisions hereof will be effective unless explicitly set forth in writing and signed by the waiving party. No waiver by any party will operate or be construed as a waiver of any failure, breach, or default not expressly identified by such written waiver, whether of a similar or different character, and whether occurring before or after that waiver. Except as otherwise set forth in this Agreement, no failure to exercise, or delay in exercising, any right, remedy, power, or privilege arising from this Agreement will operate or be construed as a waiver thereof. No single or partial exercise of any right, remedy, power, or privilege hereunder will preclude any other or further exercise thereof or the exercise of any other right, remedy, power, or privilege.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Attorneys’ Fees
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    In the event that any claim, suit, action, arbitration or proceeding is instituted or commenced by either party hereto against the other party arising out of or related to this Agreement, the prevailing party will be entitled to recover its reasonable attorneys’ fees and court costs from the non-prevailing party.
                  </Typography>
                </ListItem>

                <ListItem sx={CommonLicenseProps.listItemProps}>
                  <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                    Acceptance of Binding Agreement
                  </Typography>
                  <Typography sx={CommonLicenseProps.normalParaProps}>
                    By clicking “Yes, I agree” below, you are indicating that you have read and agree to be bound by all the terms of this Agreement.
                  </Typography>
                </ListItem>
              </List>
            </ListItem>
          </List>

          <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid #e0e0e0' }}>
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Exhibit A
            </Typography>
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Licensing Fee Schedule
            </Typography>
            <List sx={CommonLicenseProps.bulletListProps}>
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Licensing Fee
                </Typography>
                <List sx={CommonLicenseProps.bulletListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Commercial Use
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      With respect to Derivative Work for which a Customer purchases an exclusive, commercial use license, the Licensing Fee is equal to 70 percent (70%) of the net receipts received by Saagas.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Payment Terms
                </Typography>
                <List sx={CommonLicenseProps.bulletListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.bulletParaProps}>
                      30 days from receipt
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.bulletParaProps}>
                      Paid out to connected Stripe account
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
    </>
  );
};

export default CopyrightLicenseAgreementArtist;